module.exports = __webpack_public_path__ + "media/images/pic/cal-5b7231ce2e59fbcf559d44cbf58f6816.svg";